import Vue from 'vue'
import {join} from './lib/url-join'
import Store from './store'

let documents = {}

async function getDocument (id) {
  const document = id
  const api = process.env.API

  if (!document) {
    return
  }

  const url = join(api, '/document/buffer', document)
  const res = await Vue.http.get(url, { responseType: 'arraybuffer' })
  const {body, headers} = res

  const type = headers.map['content-type']
  const arrayBufferView = new Uint8Array(body)
  const blob = new Blob([arrayBufferView], { type })

  const objectURL = URL.createObjectURL(blob)

  return objectURL
}

async function bindDocument (el, binding, vnode) {
  const document = binding.value

  if (!document) {
    return
  }

  el.style.cssText += ';display:block !important;'

  if (documents[document]) {
    el.src = documents[document]
    return
  }

  const objectURL = await getDocument(document)
  el.src = objectURL

  documents[document] = objectURL
}

Vue.directive('document', {
  bind: bindDocument,
  update: bindDocument
})

const levels = {
  editor: 10,
  admin: 20,
  owner: 30
}

Vue.directive('permission', function (el, binding, vnode) {
  // Not so pretty code
  let level = binding.value

  if (level.constructor === String) {
    level = levels[level] || 10
  }

  function checkPermission () {
    const rights = Store.getters.permissionLevel

    if (level <= rights) {
      return el.style.removeProperty('display')
    }

    el.style.display = 'none'
  }

  Store.subscribe(({ type, rights }) => {
    if (type !== 'setUserPermissionLevel') {
      return
    }

    checkPermission()
  })

  checkPermission()
})



// WEBPACK FOOTER //
// ./src/directives.js